<template>
  <div id="assets-maindiv" class="page-maindiv">
    <!-- Main -->
    <div class="area-main">
      <!-- Area titolo -->
      <div class="area-top">
        <div class="area-top-title">
          <div>
            <b-icon @click="$router.back()" class="h2 backimage" aria-label="back" icon="chevron-compact-left"></b-icon>
          </div>
          <div class="flex-column">
            <h2 class="font-title1 mb-0">
              {{ $t('beni').toUpperCase() }}
            </h2>
            <div class="font-title1 flex-row">
              {{ field != null ? ("(" + field + ": " + fieldValue) + ")" : loading }}
            </div>
            <div>
              {{ assets.length + " " + $tc('risultati-n', assets.length) }}
            </div>
          </div>
        </div>
      </div>
      <div class="px-3 pt-3 flex-column">
        <p class="text-left mb-0">
          blah blah
        </p>
      </div>
      <!-- Area cards -->
      <div class="assets-cards">
        <b-card-group columns id="assets-card-columns">
          <b-card
              class="assets-card"
              no-body
              border-variant="white"
              v-for="(asset, index) in filteredAssets"
              :key="asset.preview"
          >
            <div @mouseover="hoverCard(index)" @mouseout="hoverCard(-1)">
              <b-link :to="{ path: '/asset/' + asset.id, query: { ids: filteredAssetsIds } }" style="text-decoration: none;color: #2c3e50;width: 100%">
                <b-card-img-lazy class="assets-card-image" :class="{'selected': isCardSelected(index)}" :src="asset.image" :alt="$utilities.getTranslation(asset, 'nome', $i18n.locale)" top></b-card-img-lazy>
              </b-link>
            </div>
            <b-card-text class="assets-card-num-results">
              <p class="mb-0">{{ asset.numImages + " " + $tc("immagini-n", asset.numImages) }}</p>
            </b-card-text>
            <b-link :to="'/asset/' + asset.id" style="text-decoration: none;color: #2c3e50" @mouseover="hoverCard(index)" @mouseout="hoverCard(-1)">
              <b-card-text class="assets-card-title font-title1">
                <h5 class="mb-0">{{ $utilities.getTranslation(asset, "nome", $i18n.locale) }}</h5>
              </b-card-text>
              <b-card-text class="assets-card-subtitle">
                <p class="mb-0">{{ $utilities.getTranslation(asset, "nome2", $i18n.locale) }}</p>
              </b-card-text>
            </b-link>
          </b-card>
        </b-card-group>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AssetsBy',
  data: function() {
    return {
      buttonMoreTranslationKey: "readmore",
      showOverlay: false,
      structures: null,
      collections: null,
      assets: [],
      loading: "(" + this.$t("caricamento") + "...)",
    };
  },
  created() {
    this.fetchAssets()
  },
  computed: {
    filteredAssets() {
      const assets = this.assets;
      return assets.sort((a, b) => parseInt(a.order) - parseInt(b.order));
    },
    filteredAssetsIds() {
      const assets = this.assets;
      return assets.map((a) => a.id).join();
    },
    field() {
      return this.$route.params.field;
    },
    fieldValue() {
      return this.$route.params.fieldValue;
    },
  },
  methods: {
    async fetchAssets() {
      // Collezioni
      const collectionsData = await this.$client.getItems("collezioni", {fields: ["id", "id_dipartimento", "traduzioni.*"]});
      if (collectionsData.data.length > 0)
        this.collections = collectionsData.data;

      // Strutture
      const structuresData = await this.$client.getItems("dipartimenti", {fields: ["*", "traduzioni.*"]});
      if (structuresData.data.length > 0)
        this.structures = structuresData.data;

      const assetsData = await this.$client.getItems("beni", {fields: ["id", "id_collezione", "traduzioni.*"], limit: -1, filter: {
          "traduzioni.catalogo_materia": {
            like: this.fieldValue
        }}});
      let assets = assetsData.data;
      let listOfAssetIds = "";
      for (let asset in assets) {
        listOfAssetIds += assets[asset].id + ",";
      }

      const joinsData = await this.$client.getItems("join_beni_directus_files", {fields: ["*"], limit: -1, filter: {
          id_beni: {
            in: listOfAssetIds
          }}});
      let joins = joinsData.data;
      let listOfIdDirectusFiles = "";
      for (let join in joins) {
        listOfIdDirectusFiles += joins[join].id_directus_files + ",";
      }

      const filesData = await this.$client.getFiles({limit: -1, filter: {
        id: {
          in: listOfIdDirectusFiles
        }}});
      let files = filesData.data;

      for (let asset in assets) {
        assets[asset].order = Number.MAX_VALUE;
        assets[asset].image = null;
        assets[asset].numImages = 0;
        for (let join in joins) {
          if (assets[asset].id === joins[join].id_beni) {
            assets[asset].numImages++;
            const imageId = "" + joins[join].id_directus_files;
            for (let file in files) {
              if (files[file].id != imageId)
                continue;
              // Immagini
              let assetUrl = this.$client.getAssetUrl(files[file].private_hash, {key: "directus-large-contain"});
              // Ordine di visualizzazione delle immagini (se esiste)
              if (files[file].metadata != null && files[file].metadata.order != null) {
                if (assets[asset].order > files[file].metadata.order) { // si prende l'immagine con order minimo
                  assets[asset].order = files[file].metadata.order;
                  assets[asset].image = assetUrl;
                }
              }
              if (assets[asset].image == null) { // se non è specificato order assegna comunque l'immagine
                assets[asset].image = assetUrl;
              }
            }
          }
        }
      }
      this.assets = assets.sort((a, b) => parseInt(a.order) - parseInt(b.order));
      this.loading = "";
    },
    hoverCard(selectedIndex) {
      this.selectedCard = selectedIndex
    },
    isCardSelected(cardIndex) {
      return this.selectedCard === cardIndex
    },
  }
}
</script>

<style>
</style>
